import { useQuery } from "@tanstack/react-query";
import { Phenophase } from "services/iot/models";
import { createService } from "services/serviceFactory";

export const iotBase = "/iot/";
const iotService = createService("iot");

export const usePhenophasesQueries = () => {
    const results = useQuery({
        queryKey: ["iot", "phenophases"],
        queryFn: async () => {
            const response = await iotService.get<Phenophase[]>(
                `${iotBase}Phenophase/GetPhenophases`
            );

            return response.data;
        },
    });

    const phenophasesQuery = results;

    return {
        phenophasesQuery,

        isLoading: results.isLoading,
        isError: results.isError,

        phenophases: phenophasesQuery.data ?? [],
    };
};
